import {
  ProductForecastStatus,
  ProductsSalesForecastInfoQueryKey,
  type ProductsForecastInfo
} from '@domain/materials'
import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import type {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {mutations} from '../../../../../api/mutations'
import {notifyIfErrorMessage} from '../../../../common/utils/errorHandling'

import {settingsQueryClient} from '@settings/modules/common/providers'

export const useRequestProductSalesForecast = () => {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<
    void,
    AxiosError<{message: string}>,
    Parameters<typeof mutations.requestSalesForecast>[0]
  >({
    mutationFn: mutations.requestSalesForecast,
    onError: (error) => {
      notifyIfErrorMessage(error.response?.data.message, raiseError, notify)
    },
    onSuccess: (data, {plantCode, productId, materialId}) => {
      notify('success', t('success.requestProductSalesForecast'))
      const prevData = settingsQueryClient.getQueryData<ProductsForecastInfo>([
        ProductsSalesForecastInfoQueryKey,
        plantCode,
        materialId
      ])
      if (prevData) {
        const newData = {
          ...prevData,
          [productId]: {status: ProductForecastStatus.Requested}
        }
        settingsQueryClient.setQueryData(
          [ProductsSalesForecastInfoQueryKey, plantCode, materialId],
          newData
        )
      }
      void settingsQueryClient.invalidateQueries({
        queryKey: [ProductsSalesForecastInfoQueryKey, plantCode, materialId],
        refetchType: 'all'
      })
    }
  })
}
